import { DaoService } from './../servicos/dao.service';
import { Component, OnInit } from '@angular/core';
import { SortEvent } from 'primeng/api';

@Component({
  selector: 'app-licitacao',
  templateUrl: './licitacao.component.html',
  styleUrls: ['./licitacao.component.css']
})
export class LicitacaoComponent implements OnInit {

  constructor(public dao:DaoService) { }

  ngOnInit() {
    this.carregarLicitacoes();
  }

  senha: string ="licitacaoDiviprev*";
  valSenha:any;
  permitido: boolean = false;
  mostrar: boolean = false;
  dia:any;
  descricao:any;
  categoria:any;
  categorias:any[]=[
    {label:'Pregão',value:'pregao'},
    {label:'Dispensa',value:'dispensa'},
    // {label:'Tomada de Preço',value:'tomada'},
    {label:'Inesigibilidade',value:'inesigibilidade'},
    // {label:'Convite',value:'convite'},
    {label:'Credenciamento',value:'credenciamento'},
    {label:'Concurso',value:'concurso'},
    // {label:'Chamamento',value:'chamamento'},
    {label:'Contratos ADM Vigentes',value:'contratosvigentes'},
    {label:'Convênios',value:'convenios'},
    {label:'Leilão',value:'leilao'},
    {label:'Diálogo Competitivo',value:'dialogo'},
    {label:'Concorrência',value:'concorrencia'}
  ];

  entrar(){
    if(this.senha==this.valSenha)this.permitido=true;
  }

  adicionarNovo(){
    this.mostrar = !this.mostrar;
    this.dia = null;
    this.descricao = null;
  }

  is_numeric = function(obj){
    return !Array.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
  }

  customSort(event: SortEvent) {
    
    console.log('Entrou no SORT, Evento->',event);
    event.data.sort((data1, data2) => {
        let value1 = data1[event.multiSortMeta[0].field];
        let value2 = data2[event.multiSortMeta[0].field];
        let result = null;
        console.log('value1->',value1);
        console.log('value2->',value2);
        console.log('E Numerico?->',this.is_numeric(value1));
        //console.log('event.field ->',event.multiSortMeta[0].field);
        //console.log('Data1[event.field] ->',data1[event.field]);
        //console.log(data2);

        if (value1 == null && value2 != null)
            result = -1;
        else if (value1 != null && value2 == null)
            result = 1;
        else if (value1 == null && value2 == null)
            result = 0;
        else if (!this.is_numeric(value1) && !this.is_numeric(value2)){
          console.log("É STRING");
            result = value1.localeCompare(value2);
            console.log('resultado do ESTRING->',result);
        }else{
          console.log("É COMPARATIVO");
          result = (parseInt(value1) < parseInt(value2) ) ? -1 : (parseInt(value1) > parseInt(value2) ) ? 1 : 0;
        }
            
        console.log('resultado->',result);
        console.log('retornado->',event.order * result);
        return (event.multiSortMeta[0].order *result);
    });
}

  salvar(){
    if(!this.dia){
      this.dao.toast('e','infrome a <b>Data</b>!');
      return;
    }

    if(!this.descricao || this.descricao==''){
      this.dao.toast('e','infrome a <b>Descrição</b>!');
      return;
    }

    if(!this.categoria || this.categoria==''){
      this.dao.toast('e','infrome a <b>Categoria</b>!');
      return;
    }
    
    let dados = {
      dia:this.dia,
      descricao:this.descricao,
      categoria:this.categoria
    }

   

    this.dao.submeter(dados,"salvarLicitacao").then(res=>{
      this.dao.toast('s','Registro salvo com sucesso!');
      this.dia = null;
      this.descricao = null;
      this.mostrar = false;

      this.tratarResposta(res);
    });
  }


  licitacoes:any;
  desativas:any;

  tratarResposta(res){
    this.licitacoes = [];
    this.desativas = [];
    if(res && res.length>0){
      this.licitacoes = res.filter(l=>{
        if(l.finalizado=='sim')this.desativas.push(l);
        if(l.finalizado=='nao')return l;
      });
    }
  }

  carregarLicitacoes(){
    this.dao.submeter({},"listarLicitacoes").then(res=>{
      this.tratarResposta(res);
    });
  }

  voltar(ev){
    this.licitacaoSelecionada = null;
  }

  finalizarLicitacao(li){
    let dados = {idLicitacao:li.id};
    this.dao.submeter(dados,"finalizarLicitacao").then(res=>{
      this.dao.toast('s','Licitação finalizada com sucesso!');
      this.tratarResposta(res);
    })
  }

  reativar(li){
    let dados = {idLicitacao:li.id};
    this.dao.submeter(dados,"reativarLicitacao").then(res=>{
      this.dao.toast('s','Licitação reativada com sucesso!');
      this.tratarResposta(res);
    })
  }

  excluir(li){
    let dados = {idLicitacao:li.id};
    this.dao.submeter(dados,"excluirLicitacao").then(res=>{
      this.dao.toast('s','Licitação excluida com sucesso!');
      this.tratarResposta(res);
    })
  }


  licitacaoSelecionada:any;

  inserirArquivos(lici){
    this.licitacaoSelecionada = lici;
    console.log(lici);
  }

}
